export default "__VITE_ASSET__B7C_gDyh__$_?url__"